"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonRules = void 0;
const game_rules_1 = require("../../game-rules");
class CommonRules {
    static nextTurnOrEndRules(context, playerId) {
        const playerNextTurn = context.playerManager.playerNextTurn(playerId);
        if (playerNextTurn) {
            return CommonRules.moveNextPlayerRules(context, playerNextTurn.playerId);
        }
        return CommonRules.endRoundRules();
    }
    static moveNextPlayerRules(context, nextPlayerId) {
        const moveNextPlayerRules = new game_rules_1.MoveNextPlayerRule(nextPlayerId);
        const reachTargetScoreForkRule = new game_rules_1.ReachTargetScoreForkRule(nextPlayerId, new game_rules_1.ShowControlsRule(), CommonRules.nextTurnOrEndRules(context, nextPlayerId));
        moveNextPlayerRules.setNext(reachTargetScoreForkRule);
        return moveNextPlayerRules;
    }
    static endRoundRules() {
        const croupierAutoDealRule = new game_rules_1.CroupierAutoDealRule();
        const sendAllResultsRule = new game_rules_1.SendAllResultsRule();
        croupierAutoDealRule.setNext(sendAllResultsRule);
        return croupierAutoDealRule;
    }
}
exports.CommonRules = CommonRules;
